export default "__VITE_ASSET__BI7QH8EN__"